import { isEqual } from 'lodash'
import { useEffect, useState } from 'react'

import { useAppSelector } from 'src/redux/hooks'
import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import useComponentSettings from './useComponentSettings'

/**
 * Determines if there are any changes on the page by comparing the different objects
 */
const useHasChangeOnPage = () => {
  const {
    filterBarSettings,
    filterBarOldSettings,
    keyMetricsSettings,
    keyMetricsOldSettings,
    checkboxesSettings,
    checkboxesOldSettings,
    ecosystemsSettings,
    ecosystemsOldSettings,
    multiChartsSettings,
    multiChartsSettingsOld,
  } = useComponentSettings()
  const [hasChangesOnDashboard, setHasChangesOnDashboard] = useState(false)
  const settings = useAppSelector(state => state.componentsSettings.settings)
  const selectedDashboard = useSelectedDashboardStore(s => s.selectedDashboard)

  useEffect(() => {
    let hasChange = false
    if (
      selectedDashboard &&
      selectedDashboard?.id !== 'default_dashboard' &&
      !selectedDashboard.default_dashboard
    ) {
      const filterBarIsEqual = isEqual(filterBarSettings, filterBarOldSettings)
      const keysMetricsIsEqual = isEqual(keyMetricsSettings, keyMetricsOldSettings)
      const ecosystemsIsEqual = isEqual(ecosystemsSettings, ecosystemsOldSettings)
      const checkboxesGroupIsEqual = isEqual(checkboxesSettings, checkboxesOldSettings)
      const multiChartsIsEqual = isEqual(multiChartsSettings, multiChartsSettingsOld)

      hasChange =
        !filterBarIsEqual ||
        !keysMetricsIsEqual ||
        !ecosystemsIsEqual ||
        !checkboxesGroupIsEqual ||
        !multiChartsIsEqual
    }
    setHasChangesOnDashboard(hasChange)
  }, [
    settings,
    filterBarSettings,
    filterBarOldSettings,
    keyMetricsSettings,
    keyMetricsOldSettings,
    ecosystemsSettings,
    ecosystemsOldSettings,
    checkboxesSettings,
    checkboxesOldSettings,
    multiChartsSettings,
    multiChartsSettingsOld,
    selectedDashboard,
  ])

  return { hasChangesOnDashboard, setHasChangesOnDashboard }
}

export default useHasChangeOnPage
